import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-square',
  templateUrl: './icon-square.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSquareComponent {}
